<aside class="scroll-section" #scrollTop *ngIf="(isMobileOrTabletPortrait$ | async) === false; else mobileDisplay">
  <button
    *ngIf="isShown$ | async"
    (click)="scrollToTop()"
    class="btn scroll-section__button"
    aria-label="Retourner en haut de la page"
    tabindex="0"
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
  >
    <mat-icon svgIcon="arrow_next" role="presentation" class="scroll-section__button__icon"></mat-icon>
  </button>
</aside>

<ng-template #mobileDisplay>
  <div class="scroll-section-mobile">
    <button
      class="btn-clean scroll-section-mobile__button"
      aria-label="Retourner en haut de la page"
      (click)="scrollToTop()"
    >
      <mat-icon
        svgIcon="arrow_next"
        role="presentation"
        class="scroll-section-mobile__button__icon scroll-section-mobile__button__icon--filled"
      ></mat-icon>
      Retourner en haut de la page
    </button>
  </div>
</ng-template>
